import Buttons from '../../elements/modal/genericAcceptModalButtons';
import Container from '../../atoms/container/modalContainer';
import FlavourConfig from '../../../../shared/config/flavours';
import Title from '../../atoms/text/modalTitle';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import { popRoute } from '../../../../shared/store/thunks/route.thunk';
import { store } from '../../../../shared/store/store';

function DeadmanZapperModal() {
  return (
    <Container>
      <Title>
        {TranslationManager.get(
          'MODAL.DEADMAN_ZAPPER.TITLE',
          FlavourConfig.appTitle
        )}
      </Title>
      <Buttons
        cancelAction={() => {
          store.dispatch(popRoute());
        }}
      />
    </Container>
  );
}

export default DeadmanZapperModal;
